<template>
    <RouterLink
        :to="to"
        class="container_employees"
    >
        <img
            class="img_employees"
            :src="imgSrc"
            :alt="title"
        />
        <p
            class="footer_title text_align_center"
            v-html="title"
        ></p>
        <ParallaxLine v-if="hasParallax" />
    </RouterLink>
</template>

<script setup>
import { defineProps } from 'vue';
import { RouterLink } from 'vue-router';
import ParallaxLine from '@/shared/components/parallax/ParallaxLine.vue';

defineProps({
    to: {
        type: String,
        required: true,
    },
    imgSrc: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    hasParallax: {
        type: Boolean,
        default: false,
    },
});
</script>
